import { createFileRoute, redirect } from '@tanstack/react-router'

import DEFAULT_PAGE_SIZE from '@/constants/default-page-size'
import { type SchoolYearAndBreakCommonFilter } from '@/modules/schoolSettings'
import { isFeatureFlagEnabled } from '@/utils/is-feature-flag-enabled'

export const Route = createFileRoute('/_auth/school-settings/')({
  beforeLoad: () => {
    const search: SchoolYearAndBreakCommonFilter = {
      status: 'active-and-future',
      page: 1,
      pageSize: DEFAULT_PAGE_SIZE
    }

    if (isFeatureFlagEnabled('IS_SCHOOL_YEARS_MODULE_ENABLED')) {
      throw redirect({
        replace: true,
        to: '/school-settings/years',
        search
      })
    }

    if (isFeatureFlagEnabled('IS_SCHOOL_BREAKS_MODULE_ENABLED')) {
      throw redirect({
        replace: true,
        to: '/school-settings/breaks',
        search
      })
    }

    if (isFeatureFlagEnabled('IS_SCHOOL_DAY_MODULE_ENABLED')) {
      throw redirect({
        replace: true,
        to: '/school-settings/day'
      })
    }
  }
})
